<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="labTestForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="labTest" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                labTestForm: () => import('../forms/LabTestForm'),
                labTest: () => import('../editViews/LabTest'),
                headers: [
                    { text: 'Lab', value: 'labId', table: 'labs', form: () => import('../forms/LabForm') },
                    { text: 'Test', value: 'testId', table: 'tests', form: () => import('../forms/TestForm') },
                    { text: 'Suspended On', value: 'suspendedOn', format: this.formatDate },
                    { text: 'Price', value: 'price' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    labs: [],
                    tests: [],
                    items: []
                },
                sorting: [
                    { column: "labId", direction: "ascending" },
                    { column: "testId", direction: "ascending" },
                ],
                itemsField: 'labTests',
                editPageName: 'labTest',
                apiMethod: 'LabTests',
                claimName: 'LabTests',
                formTitle: 'Lab Test',
                excelTitle: 'Lab Tests',
                hasEditPage: true,
            }
        },
    };
</script>
